/**
 * bandeau.js
 */

// Import
import "./bandeau.scss";
import $ from 'jquery';

$(document).ready(function() {
   /* function marqueelike() {
        $('.liens-bandeau li').each(function() {
            var texte = $(this).html();
            console.log($(this));
            console.log(texte);
            $(this).html('<div><span>' + texte + '</span><span>' + texte + '</span></div>');
        });
    }

    $(window).on('load', function() {
        marqueelike();
    });*/
   var liste = $('#bandeau1').html();
   /*console.log(liste);*/
   $('#bandeau1 li:last-child').html(liste)
});
